import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { CxTableService } from '../services/cx-table.service';
import { GridMode } from '../types/gridmode';
import { CellWidth, MinimumCellWidth } from '../cx-datagrid-config';

@Directive({
  selector: '[cxColumnResize]'
})
export class ColumnResizeDirective implements OnInit {
  private startX!: number;
  private isResizing = false;
  private initialWidth!: number;
  private columnIndex!: number;
  private table: any | null = null; // Initialize table as null

  @Input() gridMode: any;
  @Input() columnsLength: number = 0;
  @Input() cxColumnResizeIndex = 0;

  constructor(private el: ElementRef, private tableService: CxTableService, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    const changes = this;
    if (changes['gridMode'] || changes['columnsLength']) {
      if (this.gridMode === GridMode.Grid) { 
        let minWidth =  window.innerWidth / this.tableService.columns.filter((x) => !x.selection && x.display).length;
        minWidth = minWidth < MinimumCellWidth ? CellWidth : minWidth;
        if (changes['cxColumnResizeIndex'] > -1) {
          minWidth = this.tableService.columns[this.cxColumnResizeIndex].width;
        }
        this.renderer.setStyle(this.el.nativeElement.parentNode, 'width', minWidth + 'px');
      } else if (this.gridMode === GridMode.List) {
        // let minWidth = 100 / this.tableService.columns.filter((x) => x.listmode).length;
        // console.log(minWidth);
        // this.renderer.setStyle(this.el.nativeElement, 'width', minWidth + '%');
      }
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (this.gridMode === GridMode.List) { return; }
    event.preventDefault();
    this.startX = event.pageX;
    this.isResizing = true;
    this.initialWidth = this.el.nativeElement.parentNode.offsetWidth;

    // Find the index of the current column
    const row = this.el.nativeElement.parentElement;
    const cells = Array.from(row.children);
    this.columnIndex = this.cxColumnResizeIndex;

    this.renderer.addClass(this.el.nativeElement, 'resizing');
    this.renderer.addClass(document.body, 'resizing');

    this.table = this.findParentTable(this.el.nativeElement.parentNode);

    if (this.table) {
      const columns = this.table.querySelectorAll('th');

      const onMouseMove = (moveEvent: MouseEvent) => {
        if (this.isResizing) {
          const deltaX = moveEvent.pageX - this.startX;
          const newWidth = this.initialWidth + deltaX;

          // Update the width of the current column
          this.renderer.setStyle(this.el.nativeElement.parentNode, 'width', newWidth + 'px');
          // Update the width of the corresponding header and cell in each row
          columns[this.columnIndex].style.width = newWidth + 'px';
          this.tableService.columns[this.columnIndex].width = newWidth;

          // const rows = this.table?.querySelectorAll('tr') || [];
          // console.log(rows);
          // rows.forEach((row: any) => {
          //   const cells = row.querySelectorAll('td');
          //   if (cells[this.columnIndex]) {
          //     cells[this.columnIndex].style.width = newWidth + 'px';
          //   }
          // });

          
          // Adjust the width of the table if it has a fixed width
          // const tableWidth = parseInt(getComputedStyle(this?.table).width);
          // if (tableWidth > 0) {
          //   this.renderer.setStyle(this.table, 'width', tableWidth + deltaX + 'px');
          // }
        }
      };

      const onMouseUp = () => {
        this.isResizing = false;
        this.renderer.removeClass(this.el.nativeElement.parentNode, 'resizing');
        this.renderer.removeClass(document.body, 'resizing');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);

        this.tableService.setRandom();
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }
  }

  private findParentTable(element: HTMLElement): HTMLElement | null {
    while (element) {
      if (element.tagName === 'TABLE') {
        return element;
      }
      if (element?.parentElement) element = element.parentElement;
    }
    return null;
  }
}